<template>
  <div style="padding: 30px">
    <div v-if="is_loading" class="text-center" style="padding: 80px 0px">
      <img :src="require('@/assets/images/misc/loading.gif')" alt="" width="100px" />
    </div>

    <div v-else>
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="text-h5 mb-4">Currency Exchange Rate</h2>
            <p class="text-body-1 grey--text">
              This shows the exchange rate between Shopify currency (1 unit) and Etsy currency equivalent value.
            </p>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row>
          <v-col cols="12" md="6">
            <v-card outlined class="pa-6 text-center" height="100%">
              <v-icon x-large color="primary" class="mb-4">{{ icons.mdiCurrencyUsd }}</v-icon>
              <h3 class="text-h6 mb-2">Shopify Currency</h3>
              <p class="text-h4 primary--text font-weight-bold">1.00</p>
              <p class="text-body-2 grey--text mt-2">
                {{ shopCurrency || 'USD' }}
              </p>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="pa-6 text-center" height="100%">
              <v-icon x-large color="secondary" class="mb-4">{{ icons.mdiCurrencyUsd }}</v-icon>
              <h3 class="text-h6 mb-2">Etsy Currency Equivalent</h3>
              <p class="text-h4 secondary--text font-weight-bold">
                {{ currencyValue || '0.00' }}
              </p>
              <p class="text-body-2 grey--text mt-2">
                {{ etsyCurrency || 'N/A' }}
              </p>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-card outlined>
              <v-card-title>
                <v-icon left color="info">{{ icons.mdiInformation }}</v-icon>
                Exchange Rate Information
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <p><strong>Shopify Currency:</strong> {{ shopCurrency || 'Not set' }}</p>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <p><strong>Etsy Currency:</strong> {{ etsyCurrency || 'Not set' }}</p>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { mdiCurrencyUsd, mdiInformation } from '@mdi/js'

export default {
  data() {
    return {
      shop: null,
      is_loading: false,
      currencyValue: null,
      shopCurrency: null,
      etsyCurrency: null,
      lastUpdated: null,
      icons: {
        mdiCurrencyUsd: mdiCurrencyUsd,
        mdiInformation: mdiInformation,
      },
    }
  },
  mounted() {
    this.shop = store.getters.loggedInShop
    this.fetchCurrencyData()
  },
  methods: {
    async fetchCurrencyData() {
      try {
        this.is_loading = true
        
        // First try to get from shop object directly
        if (this.shop) {
          this.currencyValue = this.shop.currency_value || null
          this.shopCurrency = this.shop.currency || 'USD'
          
          if (this.shop.etsy_shop) {
            this.etsyCurrency = this.shop.etsy_shop.currency || null
          }
        }
        
        // Fetch shop data which should include currency_value
        let response = await axios.get(`admin/shops/${this.shop.id}/get-configurations`)
        if (response.data.success) {
          const shopData = response.data.shop || {}
          const etsyShop = shopData.etsy_shop || {}
          
          // Get currency_value from shop or etsy_shop (prioritize API response)
          this.currencyValue = shopData.currency_value || this.shop.currency_value || etsyShop.currency_value || null
          this.shopCurrency = shopData.currency || this.shop.currency || 'USD'
          this.etsyCurrency = etsyShop.currency || this.shop.etsy_shop?.currency || shopData.etsy_currency || null
          this.lastUpdated = shopData.updated_at || this.shop.updated_at || null
        }
      } catch (e) {
        console.error('Error fetching currency data:', e)
        // Fallback to shop object
        if (this.shop) {
          this.currencyValue = this.shop.currency_value || null
          this.shopCurrency = this.shop.currency || 'USD'
          if (this.shop.etsy_shop) {
            this.etsyCurrency = this.shop.etsy_shop.currency || null
          }
        }
      } finally {
        this.is_loading = false
      }
    },
  },
}
</script>

